import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { InternalLinkButton } from 'src/shared/components/InternalLinkButton';

import { CirclesRsvpConfirmationTemplate } from '../templates/CirclesRsvpConfirmationTemplate';

interface CirclesCommunityRsvpConfirmationPageParams {
    rsvpId: string;
    topicSlug: string;
}

const CirclesCommunityRsvpConfirmationPage: React.FC<unknown> = () => {
    const { rsvpId } = useParams<CirclesCommunityRsvpConfirmationPageParams>();
    const { t } = useTranslation('circles');

    return (
        <CirclesRsvpConfirmationTemplate
            rsvpId={rsvpId}
            secondaryAction={
                <InternalLinkButton variant="secondary" size="large" to="/circles">
                    {t('pages.rsvp_confirmation.actions.explore_more_circles')}
                </InternalLinkButton>
            }
        />
    );
};

export default CirclesCommunityRsvpConfirmationPage;
